import { PRIMARY_AGGREGATION_SETTING, SECONDARY_AGGREGATION_SETTING } from './aggregation';
import { SHOW_WORKFLOW_ICON_SETTING } from './showWorkflowIcon';
import { SUMMARY_PLACEMENT_SETTING } from './summaryPlacement';
export const PIPELINE_BOARD_SETTINGS = [SUMMARY_PLACEMENT_SETTING, PRIMARY_AGGREGATION_SETTING, SECONDARY_AGGREGATION_SETTING, SHOW_WORKFLOW_ICON_SETTING];